import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import { SnackbarProvider } from "notistack";
// window.addEventListener('error', e => {
//   if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
//     const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
//     const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
//     if (resizeObserverErr) {
//       resizeObserverErr.setAttribute('style', 'display: none');
//     }
//     if (resizeObserverErrDiv) {
//       resizeObserverErrDiv.setAttribute('style', 'display: none');
//     }
//   }
// });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <SnackbarProvider maxSnack={3}>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </SnackbarProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
